import { render, staticRenderFns } from "./LocalisationProviders.vue?vue&type=template&id=215051cf&"
import script from "./LocalisationProviders.vue?vue&type=script&lang=ts&"
export * from "./LocalisationProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports